export default "query($email: String!) {\n  preFilledNewsletterCheckbox(email: $email) {\n    email\n    isShown\n    isChecked\n  }\n}"